import config from "config/config"
import axios from "axios"

import * as url from "../helpers/url_helper"

export const studentRemarksApi = {
  getAllRemarks: async data => {
    const { page = 1, ...bodyData } = data // extract page from data

    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.Get_All_Student_Remarks}?page=${page}`, // page as query param
      headers: {
        "Content-Type": "application/json",
      },
      data: bodyData, // send rest as POST body (session_id, st_class, st_sec, search)
    }

    return await axios(axiosConfig)
  },

  exportRemarksReport: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.Export_Remarks_Report}`,
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
      data,
    }
    return await axios(axiosConfig)
  },
}
